import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.btn*` (assets/styles.css).
// Variants: primary (filled + lift) · ghost (outlined) · subtle (transparent) ·
//           danger (soft → fills) · dangerSolid · dangerLink.
// Sizes: md = the prototype default `.btn` (38px) · sm = `.btn-sm` (30px).
export const styles = {
  base: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kOIVth: "x1fwedmp",
    kMv6JI: "xdv2sak",
    k63SB2: "xomqrzn",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x9r1u3d",
    khDVqt: "xuxw1ft",
    kfSwDN: "x87ps6o",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1wjv31i x9kvfbb",
    kI3sdo: "x1a2a7pz xx4dj4q",
    kWCcOm: "x1t5pwa4",
    kYPGJ8: "x1s07b3s",
    $$css: true
  },
  md: {
    kZKoxP: "x16wdlz0",
    kg3NbH: "x1dey2f9",
    kGuDYH: "x2pyw9z",
    $$css: true
  },
  sm: {
    kZKoxP: "x1gnnpzl",
    kg3NbH: "xy65nll",
    kGuDYH: "x2pyw9z",
    kaIpWk: "x1d0dq8e",
    $$css: true
  },
  block: {
    kzqmXN: "xh8yej3",
    kjj79g: "xl56j7k",
    kZKoxP: "x5kalc8",
    $$css: true
  },
  primary: {
    kWkggS: "xlvhwkj",
    kMwMTN: "x1m3rtoy",
    kGVxlE: "x1lisf03",
    kIa11j: "xgdqvw5",
    k3aq6I: "x1nlf60j x6wgdar",
    $$css: true
  },
  ghost: {
    kWkggS: "x13uruat",
    kVAM5u: "x1xo1f5v",
    kMwMTN: "x1oezkus",
    kIa11j: "x1wq8w0c",
    kLmhY5: "xk080eh",
    $$css: true
  },
  subtle: {
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kIa11j: "x1wq8w0c",
    kf7JFr: "xnb8j09",
    $$css: true
  },
  danger: {
    kWkggS: "x8qqj1s",
    kVAM5u: "x1vgqim1",
    kMwMTN: "x2wi9gy",
    kIa11j: "x5ubcf1",
    kf7JFr: "x1rgp0tm",
    $$css: true
  },
  dangerSolid: {
    kWkggS: "x4qlrbh",
    kMwMTN: "xahmsqx",
    kM2cI1: "x1ii4yv3",
    k3aq6I: "x1nlf60j x6wgdar",
    $$css: true
  },
  dangerLink: {
    kWkggS: "xjbqb8w",
    kMwMTN: "x2wi9gy",
    kIa11j: "x1m8c8c8",
    $$css: true
  }
};